module.exports = __webpack_public_path__ + "static/media/debrief-home-bg-wide.583ff834.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/bg/debrief-home-bg-wide.png
// module id = 1423
// module chunks = 0